import React from "react"
import PropTypes from "prop-types"

class ExternalLink extends React.Component {
  static propTypes = {
    href: PropTypes.string,
  }

  render() {
    const { href } = this.props;
    if (!href) {
      return null;
    }

    let openHref = href;
    if (!openHref.startsWith('http')) {
      openHref = `//${openHref}`;
    }

    return (
      <span className="ExternalLink">
        {href}
        <a href={openHref} target="_blank" rel="noopener noreferrer" title={'打开新网页'}>
          <i className="fas fa-external-link-alt"/>
        </a>
      </span>
    );
  }
}

export default ExternalLink;
